<template>
  <div class="space-y-8">
    <BaseCard>
      <BaseCardBody>
        <div class="space-y-4">
          <component
            v-for="property in properties"
            :key="property.name"
            :is="property.component"
            :value="accProduct[property.name]"
            v-bind="property.props"
          />
          <MediaManager :acc-product-id="accProductId" />
        </div>
      </BaseCardBody>
    </BaseCard>

    <DeleteProduct :acc-product-id="accProductId" />
  </div>
</template>

<script>
import MediaManager from './MediaManager.vue';
import DeleteProduct from './DeleteProduct.vue';

export default {
  inject: ['updateAccProduct'],
  components: {
    MediaManager,
    DeleteProduct,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showActions: false,
      properties: [
        {
          name: 'name',
          component: () => import('../../StringProperty.vue'),
          props: {
            label: 'Name',
            name: 'name',
            rules: { required: true, max: 255 },
            saveAction: this.updateAccProduct,
            inputClasses: 'w-2/3',
          },
        },
        {
          name: 'sku',
          component: () => import('../../StringProperty.vue'),
          props: {
            label: 'SKU',
            name: 'sku',
            rules: { required: true, max: 255 },
            saveAction: this.updateAccProduct,
            inputClasses: 'w-1/2',
          },
        },
        {
          name: 'shortDescription',
          component: () => import('../../TextProperty.vue'),
          props: {
            label: 'Short description',
            name: 'shortDescription',
            rules: { max: 500 },
            saveAction: this.updateAccProduct,
          },
        },
      ],
    };
  },
  computed: {
    accProduct() {
      return this.$store.state.entities.accProducts.byId[this.accProductId];
    },
  },
};
</script>
